//#region IMPORT
import React from 'react';
/** Services Import */
/** Components Import */
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1, getRowStyle1 } from './NOT_BASIC_01_ColumnDefs';
import { useSelector } from 'react-redux';
//#endregion

function NOT_BASICF_01(props) {
  // #region 변수
  const columnDefs = getColumnDefs1(props);
  const searchInfo = useSelector((state) => state.SearchInfo);
  //#endregion

  return (
    <BusinessGridCommon
      deleteYn1="N"
      addClick1={() => {
        props.navigate('/Notice2', {
          state: { coCd: searchInfo.coCd },
        });
      }}
      refreshClick1={() => props.Search1()}
      gridRef={props.gridRef1}
      rowData={props.rowData}
      columnDefs={columnDefs}
      getRowStyle={getRowStyle1}
      setSelectedRowData={props.setSelectedRowData}
      setChangedRowData={props.setChangedRowData}
      onCellClicked={(e) => {
        props.setSelectedRowData(e.data); // 선택된 행 저장

        props.navigate('/Notice1', {
          state: {
            data: e.data,
            coCd: searchInfo.coCd,
          },
        });
      }}
    />
  );
}

export default NOT_BASICF_01;
